import { Table, Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { FecAccountMatchType } from '../../../../../../enums/fecAccountMatchType'
import type { FecAccountMapping } from '../../../../../../types/fecAccountMapping'
import { AccountStatusBadge } from '../AccountStatusBadge'

const TYPE_TRANSLATION_KEYS: Record<FecAccountMatchType, string> = {
  [FecAccountMatchType.CustomLabel]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.type.custom_label',
  [FecAccountMatchType.Standard]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.type.standard',
  [FecAccountMatchType.SubAccount]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.type.sub_account',
  [FecAccountMatchType.Unknown]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.type.unknown',
}

interface ChartOfAccountsTableRowProps {
  mapping: FecAccountMapping
}

export const ChartOfAccountsTableRow = ({ mapping }: ChartOfAccountsTableRowProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Table.Row>
      <Table.Cell>
        <Typography.Text>{mapping.accountNo}</Typography.Text>
      </Table.Cell>
      <Table.Cell>
        <Typography.Text>{mapping.label}</Typography.Text>
      </Table.Cell>
      <Table.Cell>
        <Typography.Text>{t(TYPE_TRANSLATION_KEYS[mapping.matchType])}</Typography.Text>
      </Table.Cell>
      <Table.Cell>
        <AccountStatusBadge status={mapping.status} />
      </Table.Cell>
    </Table.Row>
  )
}
